<script setup lang="ts">
const { size = "default" } = defineProps<{
  url: string
  size?: "default" | "sm"
}>()
</script>

<template>
  <div class="flex w-fit flex-col items-center gap-1">
    <img
      :src="url"
      alt=""
      class="object-contain"
      :class="size == 'default' ? 'max-h-9' : 'max-h-7'"
    />
    <span class="text-[9px] leading-none whitespace-nowrap text-zinc-400">
      Powered by Moxso
    </span>
  </div>
</template>
